import { CustomOutlinedButton, CustomContainedButton, Translate } from '.'
import { Modal, Box, Typography, useMediaQuery } from '@mui/material'
import { Warning } from '..'

interface ConfirmModalProps {
  name: string
  modalOpen: boolean
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  handleClick: () => void
}

export const ConfirmModal = ({
  name,
  modalOpen,
  setModalOpen,
  handleClick,
}: ConfirmModalProps) => {
  const matches = useMediaQuery('(min-width:750px)')
  return (
    <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          maxWidth: '560px',
          transform: 'translate(-50%, -50%)',
          bgcolor: '#fff',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
          borderRadius: '8px',
          outline: 'none',
        }}
      >
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          margin={matches ? '50px 60px' : '30px'}
          textAlign={'center'}
          width={matches ? 'auto' : '75vw'}
          flexDirection={'column'}
        >
          <Warning />
          <Typography
            fontSize={'20px'}
            fontWeight={500}
            color={'secondary'}
            sx={{
              marginTop: '15px',
              paddingX: matches && '40px',
            }}
          >
            <Translate
              entityName={`${name}.modal.title`}
              defaultMessage={'Are you sure you want to... ?'}
            />
          </Typography>
          <Translate entityName={`${name}.modal.text`} defaultMessage={' '}>
            {(placeholder) =>
              placeholder != ' ' && (
                <Typography
                  fontSize={'14px'}
                  fontWeight={400}
                  sx={{
                    marginTop: '15px',
                  }}
                >
                  {placeholder}
                </Typography>
              )
            }
          </Translate>
          <Box display={'flex'} justifyContent={'center'} marginTop={'28px'}>
            <Translate
              entityName={`${name}.modal.button.cancel`}
              defaultMessage={' '}
            >
              {(placeholder) =>
                placeholder != ' ' && (
                  <CustomOutlinedButton
                    variant="outlined"
                    color="primary"
                    sx={{ width: 'auto' }}
                    onClick={() => setModalOpen(false)}
                  >
                    {placeholder}
                  </CustomOutlinedButton>
                )
              }
            </Translate>
            <CustomContainedButton
              sx={{ marginLeft: '16px' }}
              variant="contained"
              color="primary"
              onClick={() => {
                handleClick()
                setModalOpen(false)
              }}
            >
              <Translate
                entityName={`${name}.modal.button.ok`}
                defaultMessage={'Ok'}
              />
            </CustomContainedButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmModal
